import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Buffer} from "buffer";

@Injectable({
  providedIn: 'root'
})
export class QuickfiltersService {

  constructor(private http: HttpClient) { }

  getAllFilters(filterType: 'quickfilter' | 'standardfilter' = 'quickfilter'): Observable<any>{
    return this.http.get(`${environment.yomaApiURL}/${filterType}`);
  }

  getFilter(name: string, filterType: 'quickfilter' | 'standardfilter' = 'quickfilter'):Observable<any>{
    let encoded = Buffer.from(name).toString('base64')
    return this.http.get(`${environment.yomaApiURL}/${filterType}/${encoded}`);
  }

  deleteFilter(name: string, filterType: 'quickfilter' | 'standardfilter' = 'quickfilter'): Observable<any>{
    let encoded = Buffer.from(name).toString('base64')
    return this.http.delete(`${environment.yomaApiURL}/${filterType}/${encoded}`);
  }


  postFilter(name: string, filter: any, filterType: 'quickfilter' | 'standardfilter' = 'quickfilter'){
    let encoded = Buffer.from(name).toString('base64')
    return this.http.post(`${environment.yomaApiURL}/${filterType}/${encoded}`, filter);
  }
}
